/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Standings_Score_OptInputs */



/**
* | output |
* | --- |
* | "GW/VP/TP (prelims only)" |
*
* @param {League_Standings_Score_OptInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_standings_score_opt = /** @type {((inputs?: League_Standings_Score_OptInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Standings_Score_OptInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("GW/VP/TP (préliminaires uniquement)")
	if (locale === "es") return /** @type {LocalizedString} */ ("GW/VP/TP (solo preliminares)")
	if (locale === "pt") return /** @type {LocalizedString} */ ("GW/VP/TP (apenas preliminares)")
	if (locale === "it") return /** @type {LocalizedString} */ ("GW/VP/TP (solo preliminari)")
	return /** @type {LocalizedString} */ ("GW/VP/TP (prelims only)")
});